import { createSlice } from '@reduxjs/toolkit';

export const updateSubscriptionInfoSlice = createSlice({
  name: 'updateSubscriptionInfo',
  initialState: {
  },
  reducers: {
    setUpdateSubscriptionInfo: (state, action) => {
      return action.payload;
    },
  },
});

export const { setUpdateSubscriptionInfo } = updateSubscriptionInfoSlice.actions;

export default updateSubscriptionInfoSlice.reducer;